(function () {
  'use strict';

  function initSlider(root) {
    var swiperEl = root.querySelector('[data-kyst-slider-swiper]');
    var progressFill = root.querySelector('[data-kyst-slider-progress-fill]');
    var captions = Array.prototype.slice.call(root.querySelectorAll('[data-kyst-slider-captions] .kyst-slider__caption'));
    var prevBtn = root.querySelector('[data-kyst-slider-prev]');
    var nextBtn = root.querySelector('[data-kyst-slider-next]');

    if (!swiperEl || typeof window.Swiper === 'undefined') return;

    var slides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
    var total = slides.length;
    if (total === 0) return;

    // The title/text for every slide already exist as real HTML (rendered
    // by Liquid, readable by search engines) — we only toggle which one is
    // visible, instead of writing text into the page with JavaScript.
    function updateCaption(index) {
      captions.forEach(function (caption) {
        var isActive = caption.getAttribute('data-index') === String(index);
        caption.classList.toggle('is-active', isActive);
      });

      if (progressFill) progressFill.style.width = ((index + 1) / total) * 100 + '%';
    }

    // Set the initial state before Swiper finishes initializing.
    updateCaption(0);

    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 400,
      threshold: 5,
      on: {
        slideChange: function () {
          updateCaption(this.activeIndex);
        }
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        swiper.slidePrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        swiper.slideNext();
      });
    }
  }

  function initAll() {
    var sliders = document.querySelectorAll('[data-kyst-slider]');
    sliders.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('[data-kyst-slider]');
    if (slider) initSlider(slider);
  });
})();